/**
 * WebFoxx Visual Asset System (VAS v1.0) — Page Illustration Mapping Registry
 * Maps page routes to explicit unDraw illustration assets, categories, and positions.
 */

export interface PageIllustrationConfig {
  name: string;
  category: string;
  alt: string;
}

export const PAGE_ILLUSTRATIONS: Record<string, PageIllustrationConfig> = {
  '/': {
    name: 'learning',
    category: 'education',
    alt: 'WebFoxx Structured Learning',
  },
  '/login': {
    name: 'authentication',
    category: 'authentication',
    alt: 'Authentication & Sign In',
  },
  '/signup': {
    name: 'welcome',
    category: 'onboarding',
    alt: 'Welcome to WebFoxx Academy',
  },
  '/forgot-password': {
    name: 'secure-login',
    category: 'authentication',
    alt: 'Reset Password & Account Security',
  },
  '/assessment': {
    name: 'quiz',
    category: 'testing',
    alt: 'Mock Tests & Exam Practice',
  },
  '/syllabus': {
    name: 'studying',
    category: 'education',
    alt: 'CUET (UG & PG) Question Bank & Syllabus',
  },
  '/ai': {
    name: 'artificial-intelligence',
    category: 'ai',
    alt: 'WebFoxx AI Tutor',
  },
  '/analytics': {
    name: 'analytics',
    category: 'analytics',
    alt: 'Performance & Accuracy Analytics',
  },
  '/revision': {
    name: 'studying',
    category: 'education',
    alt: 'Revision workspace and daily study plan',
  },
  '/bookmarks': {
    name: 'studying',
    category: 'education',
    alt: 'Personal study library and saved bookmarks',
  },
  '/pricing': {
    name: 'education',
    category: 'education',
    alt: 'WebFoxx Access Plans & Pricing',
  },
  '/about': {
    name: 'community',
    category: 'community',
    alt: 'WebFoxx Academy Community & Platform',
  },
  '/support': {
    name: 'teacher',
    category: 'education',
    alt: 'WebFoxx Faculty Support & Guidance',
  },
  '/404': {
    name: 'page-not-found',
    category: 'empty',
    alt: '404 Page Not Found',
  },
};

export function getIllustrationForPage(pageRoute: string): PageIllustrationConfig {
  const normalized = pageRoute.split('?')[0].split('#')[0].toLowerCase();
  if (PAGE_ILLUSTRATIONS[normalized]) {
    return PAGE_ILLUSTRATIONS[normalized];
  }

  // Prefix matching for nested paths (e.g. /assessment/analytics -> /assessment)
  const segments = normalized.split('/').filter(Boolean);
  if (segments.length > 0) {
    const baseRoute = '/' + segments[0];
    if (PAGE_ILLUSTRATIONS[baseRoute]) {
      return PAGE_ILLUSTRATIONS[baseRoute];
    }
  }

  return {
    name: 'education',
    category: 'education',
    alt: 'WebFoxx Academy',
  };
}
